export const BUZZGAMES = 'buzzgames';
export const IFRAME_WIDGET = 'IFRAME_WIDGET';
export const HIGHLIGHT_CSS_CLASS = 'highlight';
export const ENTER_DRAW_ACTION = 'enterDrawAction';
export const EVENT_GAME_CHANGE_SCROLL = 'EVENT_GAME_CHANGE_SCROLL';

export const DYNAMIC_CATEGORIES = {
    ALL_CATEGORY: 'All',
    FAVOURITES: 'Favourites',
    RECENTLY: 'Recently'
};

export const GAME_EVENTS = {
    GAME_PORTLET_CATEGORY_CHANGE: 'gamePortletCategoryChange',
    GAME_LAUNCH: 'gameGameLaunch',
    GAME_POSITION: 'gameGamePosition',
    GAME_FAVORITES_CHANGE: 'gameFavoritesChange',
    GAME_PORTLET_SORT: 'gamePortletSort',
    GAME_PORTLET_SEARCH: 'gamePortletSearch',
    GAME_PORTLET_VIEW: 'gamePortletView',
    GAME_PORTLET_DISPLAY: 'gamePortletDisplay'
};

/* eslint-disable camelcase */
export const PGG_CATEGORY_MAP = {
    'Because you played': 'because_you_played-all',
    'Popular All': 'popular-all',
    'Popular Arcade': 'popular-arcade',
    'Popular Blackjack': 'popular-blackjack',
    'Popular Jackpots': 'popular-jackpots',
    'Popular Live': 'popular-live',
    'Popular Macau': 'popular-macau',
    'Popular Roulette': 'popular-roulette',
    'Popular Scratch Cards': 'popular-scratch_cards',
    'Popular Slots': 'popular-slots',
    'Popular Table and Card Games': 'popular-table_and_card_games',
    'Popular Video Poker': 'popular-video_poker',
    'Recommended All': 'recommended-all',
    'Recommended Arcade': 'recommended-arcade',
    'Recommended Blackjack': 'recommended-blackjack',
    'Recommended Jackpots': 'recommended-jackpots',
    'Recommended Live': 'recommended-live',
    'Recommended Macau': 'recommended-macau',
    'Recommended Roulette': 'recommended-roulette',
    'Recommended Scratch Cards': 'recommended-scratch_cards',
    'Recommended Table and Card Games': 'recommended-table_and_card_games',
    'Recommended Video Poker': 'recommended-video_poker',
    'Recommended slots': 'recommended-slots',
    'Trending All': 'trending-all',
    'Trending Arcade': 'trending-arcade',
    'Trending Blackjack': 'trending-blackjack',
    'Trending Jackpots': 'trending-jackpots',
    'Trending Live': 'trending-live',
    'Trending Macau': 'trending-macau',
    'Trending Roulette': 'trending-roulette',
    'Trending Scratch Cards': 'trending-scratch_cards',
    'Trending Slots': 'trending-slots',
    'Trending Table and Card Games': 'trending-table_and_card_games',
    'Trending Video Poker': 'trending-video_poker'
};
/* eslint-enable camelcase */
